import Walnuts from "./Walnuts";

export default Walnuts;